import React from 'react'
import { SSRProvider } from 'react-bootstrap'

import 'academicons/css/academicons.min.css'

import './src/styles/bootstrap-packages.scss'
import './src/styles/global.css'

export const wrapRootElement = ({ element }) => (
  <SSRProvider>{element}</SSRProvider>
)
